import script from "./MerchantImageDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./MerchantImageDialog.vue?vue&type=script&lang=ts&setup=true"

import "./MerchantImageDialog.vue?vue&type=style&index=0&id=0ee835aa&lang=scss&scoped=true"
import "./MerchantImageDialog.vue?vue&type=style&index=1&id=0ee835aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee835aa"]])

export default __exports__